import type { TranslationSchema } from '../zh';

const pricing: TranslationSchema['pricing'] = {
  title: 'Purchase / Upgrade',
  cycle_month: 'Monthly',
  cycle_year: 'Yearly',
  per_month: '/ mo',
  per_year: '/ yr',
  days: '{{count}} days',
  months: '{{count}} months',
  original: 'Was {{price}}{{unit}}',
  per_day: 'As low as ¥{{price}}/day',
  start_trial: 'Start trial',
  current_plan: 'Current plan',
  upgrade: 'Upgrade',
  current_badge: 'Current',
  purchase_pending: 'Checkout is coming soon',
  plans_load_failed: 'Could not load plans',
  no_plans: 'No plans to show',
  packages_load_failed: 'Could not load add-on packages',
  no_packages: 'No add-on packages to buy',
  permanent: 'Permanent',
  no_price: 'No price for this region',
  select_spec: 'Choose plan',
  buy: 'Buy',
  buy_now: 'Buy now',
  unavailable: 'Not available',
  basic_included: 'Included with registration. No purchase needed.',
  not_supported: 'Not included',
  per_day_amount: 'As low as {{price}} / day',
  currency: 'Currency',
  currency_cny: 'CNY',
  pay_method: 'Payment method',
  pay_wechat: 'WeChat',
  pay_alipay: 'Alipay',
  pay_bank: 'Bank transfer',
  plan_price: 'Plan price',
  coupon: 'Coupon',
  select_coupon: 'Select coupon',
  pay_amount: 'Amount due',
  pay_now: 'Pay now',
  agree_terms: 'By paying you agree to the User Agreement',
  benefits: 'Benefits',
  pay_channel_unsupported: 'This payment method is not available yet',
  pay_create_failed: 'Could not create the order',
  pay_waiting: 'Complete payment',
  pay_qr_hint: 'Scan with the matching app to pay',
  pay_open_link: 'Open payment page',
  pay_success: 'Payment successful',
  pay_failed: 'Payment failed',
  pay_closed: 'Payment closed',
  pay_polling: 'Waiting for payment…',
  pay_order_no: 'Order {{orderNo}}',
  pay_invalid_sku: 'Select a valid price option',
  pay_invalid_plan: 'Missing plan code',
  pay_invalid_package: 'Missing package code',
  pay_invalid_amount: 'Invalid amount',
  period_DAY: 'day',
  period_WEEK: 'week',
  period_MONTH: 'month',
  period_TOTAL: 'total',
  period_NONE: 'ongoing',
  trial_name: 'Trial',
  trial_desc: '2 stores · 10 emails (trial)',
  pro_name: 'Pro',
  pro_desc: '5 stores · 3,000 emails/month',
  deluxe_name: 'Deluxe',
  deluxe_desc: '10 stores · 10,000 emails/month',
  feat_square: 'Creator square',
  feat_dm: 'Direct messages',
  feat_mailbox: 'Platform mailbox',
  feat_shops: 'Authorized stores',
  feat_trial_all: 'Everything in Trial',
  feat_script: 'Script templates',
  feat_invite: 'Targeted invitations',
  feat_dedupe: 'High-frequency dedupe',
  feat_email: 'Email quota',
  feat_pro_all: 'Everything in Pro',
  feat_dashboard: 'Team dashboard',
  feat_members: 'Member management',
  feat_ticket: 'Priority support',
  quota_mail_trial: '10 emails',
  quota_mail_pro: '3,000 emails/month',
  quota_mail_deluxe: '10,000 emails/month',
  quota_shop_2: '2 stores',
  quota_shop_5: '5 stores',
  quota_shop_10: '10 stores'
};

export default pricing;
